module.exports = __webpack_public_path__ + "af2d6567bdb199866a765da9ce36cd61.png";